

















import { Vue, Component, InjectReactive, Prop } from 'vue-property-decorator'
import FlashMessage from '@/components/common/FlashMessage.vue'
import LoginForm from './LoginForm.vue'

@Component({
  components: { LoginForm, FlashMessage },
})
export default class LoginHero extends Vue {
  @InjectReactive()
  flashMessages!: object

  // computed
  get loggingIn(): any {
    return this.$store.state.authentication.status.loggingIn
  }
}
